<lib-prod-form [fields]="fields" (onSubmitEvent)="submit($event)" [data]="data" [formButtons]="formButtons"></lib-prod-form>

